import { get, isEqual, isNil, omitBy, pick } from "lodash";
import { usesFromUsages } from "utils/helpers/documentTemplates";
import { MAPPING_TYPES } from "../../constants";

const CHILD_LOOP_PLACEHOLDER = { type: MAPPING_TYPES.CHILD_LOOP };
const DRAFT_KEYS = ["name", "anchors", "anchorMappings", "uses", "proposals"];

export const PROPOSAL_STATUSES = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  DISMISSED: "dismissed",
  NONE: "none",
};

export const contentOfTemplate = (template) => ({
  name: get(template, "name") ?? "",
  anchors: get(template, "anchors") ?? [],
  anchorMappings: get(template, "anchorMappings") ?? {},
  uses: usesFromUsages(get(template, "usages")),
  proposals: {},
});

export const contentOfDraft = (draft) => ({
  name: get(draft, "content.name") ?? "",
  anchors: get(draft, "content.anchors") ?? [],
  anchorMappings: get(draft, "content.anchorMappings") ?? {},
  uses: get(draft, "content.uses") ?? [],
  proposals: get(draft, "content.proposals") ?? {},
});

export const draftState = ({ draft, template }) =>
  isNil(draft)
    ? {
        content: contentOfTemplate(template),
        revision: null,
        pendingFile: null,
      }
    : {
        content: contentOfDraft(draft),
        revision: draft.revision,
        pendingFile: get(draft, "content.pendingFile") ?? null,
      };

export const completeUses = (uses) =>
  (uses || []).filter((use) => !isNil(use.insurancePlanId));

export const meaningfulMappings = (mappings) =>
  omitBy(mappings || {}, (mapping) => isEqual(mapping, CHILD_LOOP_PLACEHOLDER));

export const contentKey = (content) =>
  JSON.stringify({
    name: content.name,
    anchors: content.anchors,
    anchorMappings: meaningfulMappings(content.anchorMappings),
    uses: completeUses(content.uses),
  });

export const draftPayload = (content) => ({
  ...pick(content, DRAFT_KEYS),
  uses: completeUses(content.uses),
});
